import { Map, fromJS } from "immutable";
import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

const billingOrder = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.SWITCH_TO_SUBSCRIPTION_PLAN_SUCCESS:
    case actionTypes.EDIT_BILLING_ORDER_SUCCESS:
    case actionTypes.FETCH_BILLING_ORDER_SUCCESS: {
      if (
        action.response &&
        action.response.entities &&
        action.response.entities.billingOrder &&
        action.response.result &&
        action.response.result.single
      ) {
        return Map(action.response.entities.billingOrder[action.response.result.single]);
      }

      return state;
    }
    case actionTypes.SET_BILLING_ORDER_STEP:
      return state.set(`step`, action.step);
    case actionTypes.COMPLETE_BILLING_ORDER_SUCCESS: {
      if (action && action.response && action.response.is_paid) {
        return state.set(`status`, `success`);
      }
      return state;
    }
    default:
      return state;
  }
};

const loadingBillingOrder = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BILLING_ORDER_LOADING:
      return true;
    case actionTypes.FETCH_BILLING_ORDER_SUCCESS:
    case actionTypes.FETCH_BILLING_ORDER_ERROR:
      return false;
    default:
      return state;
  }
};

const completingBillingOrder = (state = false, action) => {
  switch (action.type) {
    case actionTypes.COMPLETE_BILLING_ORDER_LOADING:
    case actionTypes.COMPLETE_BILLING_ORDER_SUCCESS:
      return true;
    case actionTypes.COMPLETE_BILLING_ORDER_ERROR:
    case actionTypes.CLOSE_BILLING_ORDER_PROCESSING_SCREEN:
      return false;
    default:
      return state;
  }
};

const paymentError = (state = false, action) => {
  switch (action.type) {
    case actionTypes.COMPLETE_BILLING_ORDER_ERROR:
      return true;
    default:
      return state;
  }
};

const thankYou = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_THANK_YOU_SUCCESS: {
      if (action && action.response && action.response.message) {
        return fromJS(action.response.message);
      }
      return state;
    }
    default:
      return state;
  }
};

export default combineReducers({
  billingOrder,
  completingBillingOrder,
  paymentError,
  thankYou,
  loadingBillingOrder,
});
